import { MessageTypeColor } from "@/types";
import {
  botMessageColors,
  botMessageColorsDark,
  userMessageColors,
  userMessageColorsDark,
} from "../../../../colors/colors";
import { useTheme } from "@mui/material/styles";

export const useTextMessageStyles = (
  isBot: boolean,
  variant: MessageTypeColor = "default",
) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const messageColors = isBot
    ? isDark
      ? botMessageColorsDark
      : botMessageColors
    : isDark
      ? userMessageColorsDark
      : userMessageColors;

  const colors = messageColors[variant] || messageColors.default;
  const flashColors = theme.palette.flashColors;

  return {
    container: {
      position: "relative",
      borderRadius: 8,
      p: 2,
      color: colors.text,
      fontFamily: "Red Hat Display",
      fontWeight: 500,
      display: "flex",
      flexDirection: "column",
      gap: "7px",
      background: flashColors.flashBg,
      border: "7.5px solid transparent",
      backgroundImage: `linear-gradient(${flashColors.flashBg}, ${flashColors.flashBg}), linear-gradient(135deg, ${flashColors.flash1} 0%, ${flashColors.flash2} 33%, ${flashColors.flash3} 66%, ${flashColors.flash4} 100%)`,
      backgroundOrigin: "border-box",
      backgroundClip: "padding-box, border-box",
    },
    containerMessage: {
      background: flashColors.flashBg,
      borderRadius: 15,
      color: colors.text,
      fontFamily: "Red Hat Display",
      fontWeight: 500,
      display: "flex",
      flexDirection: "column",
      gap: "5px",
    },
    messageRow: {
      borderRadius: 3,
      p: "8px",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "baseline",
      color: colors.text,
      fontFamily: "Red Hat Display",
      fontWeight: 500,
      fontSize: "16px",
    },
    titleRow: {
      display: "inline-block",
      alignSelf: "flex-start",
      width: "fit-content",
      maxWidth: "calc(100% - 16px)",
      boxSizing: "border-box",
      mt: 1,
      mr: 1,
      ml: 1,
      fontWeight: 700,
      fontSize: { xs: "0.9375rem", sm: "1.125rem", md: "1.1875rem" },
      color: "#FFFFFF",
      backgroundColor: theme.palette.mode === "dark" ? "#2E3192" : "#7B68EE",
      px: { xs: 2.5, sm: 2.75 },
      py: { xs: 1.25, sm: 1.125 },
      borderRadius: { xs: "14px", sm: "16px" },
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflow: "visible",
      ...(theme.palette.mode === "dark"
        ? {
            boxShadow:
              "0 2px 14px rgba(12, 16, 48, 0.55), 0 0 0 1px rgba(255, 255, 255, 0.06)",
          }
        : {}),
      [theme.breakpoints.down("sm")]: {
        maxWidth: "calc(100% - 16px)",
        wordBreak: "normal",
        overflowWrap: "break-word",
        lineHeight: 1.4,
      },
    },
    timestamp: {
      fontSize: "12px",
      whiteSpace: "nowrap",
      alignSelf: "flex-end",
      color: colors.timeColor,
      fontFamily: "Red Hat Display",
      fontWeight: 500,
    },
    collapseContainer: {
      display: "inline-flex",
      flexWrap: "wrap",
      alignItems: "baseline",
      backgroundColor: colors.background,
      borderRadius: 3,
      p: 2,
      color: colors.text,
      fontFamily: "Red Hat Display",
      fontWeight: 500,
    },
    collapseToggle: {
      display: "flex",
      cursor: "pointer",
    },
    collapseToggleText: {
      mr: 0.5,
      color: colors.linkColor || "#06B6D4",
      fontFamily: "Red Hat Display",
      fontWeight: 500,
    },
    collapseToggleIcon: (isCollapsed: boolean) => ({
      fontSize: 18,
      transform: isCollapsed ? "rotate(0deg)" : "rotate(180deg)",
      transition: "transform 0.3s",
      color: colors.linkColor || "#06B6D4",
      fontFamily: "Red Hat Display",
      fontWeight: 500,
    }),
    collapseTimestamp: {
      opacity: 0.7,
      fontSize: "0.75rem",
      whiteSpace: "nowrap",
      alignSelf: "flex-end",
      fontFamily: "Red Hat Display",
      fontWeight: 500,
    },
  };
};
